import roleinterface from "../interfaces/roleinterface.js"
import userroleinterface from "../interfaces/userroleinterface.js"

export default {
    async getUserRoles(user, userRoles) {
        let roles = null;
        let selectedRoles = null;

        await roleinterface.getRoles(result => {
            roles = result;
        });

        await userroleinterface.getUserRolesForUser(user.userId,
            rolesForUser => {
                selectedRoles = rolesForUser;
            });

        let rolesForUser = [];

        if (roles != null) {
            for (const role of roles) {
                let userRole = {
                    userRoleId: null,
                    roleSelected: false,
                    user: {
                        userId: user.userId,
                        userName: user.userName
                    },
                    role: {
                        roleId: role.roleId,
                        name: role.name,
                        description: role.description,
                        hierarchy: role.hierarchy
                    }
                };

                if (selectedRoles != null) {
                    selectedRoles.forEach(function (selectedRole) {
                        if (selectedRole.role != null && selectedRole.role.roleId === role.roleId) {
                            userRole.userRoleId = selectedRole.userRoleId;
                            userRole.roleSelected = true;
                        }
                    });
                }

                rolesForUser.push(userRole);
            }
        }
        userRoles(rolesForUser);
    }
}


// WEBPACK FOOTER //
// ./src/managers/userrolemanager.js